export default "/build/images/031-4-300x300.png?9bc0415ed82c0c81be50133c9558e010";